const RentPaymentTypeEnum = {
  BANK_ACCOUNT: 'BANK_ACCOUNT',
  CREDIT_CARD: 'CREDIT_CARD',
  PREPAID: 'PREPAID',
  DEBIT_CARD: 'DEBIT_CARD',
  OFFLINE: 'OFFLINE',
  LVBLE: 'LVBLE',
};

export default RentPaymentTypeEnum;
